module.exports = __webpack_public_path__ + "img/1.53a9c3e3.jpg";